<template>
    <p :class="textClass" v-text="message" style="margin-bottom: 0; font-size: 1.5em"></p>
</template>
<script>
import {
  LOG_INFO,
  LOG_SUCCESS,
  LOG_ERROR,
  LOG_WARNING
} from "../constants/log-message-types";

export default {
  name: "log-message",
  computed: {
    textClass() {
      switch (this.type) {
        case LOG_INFO:
          return "black--text";
        case LOG_SUCCESS:
          return "green--text";
        case LOG_WARNING:
          return "orange--text";
        case LOG_ERROR:
          return "red--text";
      }
    }
  },
  props: {
    message: {
      type: String
    },
    type: {
      type: String,
      default: LOG_INFO
    }
  }
};
</script>
